import { createContext, useCallback, useContext, useMemo, useState } from "react";
// import axios from "axios";

import { AuthContext } from "./auth.context";

import { COLORS } from "utils/lists.utils";
import { changeWhere, getIndexWhere, getItemWhere } from "utils/array.utils";

export const ClientsContext = createContext({
	clients: [],
	addNewClient: () => {},
	updateCompanyInfo: () => {},
	updateCompanyInfoPartially: () => {},
	updateEmployees: () => {},
	downloadClient: () => {},
	deleteClient: () => {},
});

const CLIENTS = [
	{
		companyType: 0,
		name: "Kate",
		surname: "Bush",
		username: "_KateBush",
		vatNumber: "UK 4444444444",
		jobTitle: "Singer",
		email: "katebush@gmail.com",
		phone: "+44 7700 900651",
		country: "United Kingdom",
		city: "London",
		address: "Upside Hill Street 99",
		zipCode: "1978",
		id: "123",
		createdAt: "September 19, 2003",
		color: COLORS[1],
		subscription: 0,
		archivePeriod: 1,
		safeLockingPeriod: 2,
		liveChat: 0,
		mobile: 0,
		filler: { done: 100, message: 20, invoices: 13 },
	},
	{
		companyType: 1,
		company: {
			name: "Spotify",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[2],
			type: "Limited",
			clientType: 1,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010929",
		filler: { done: 100, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane",
				surname: "Doe",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole",
				surname: "Kidman",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Linkedin",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[4],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010930",
		filler: { done: 10, message: 200, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "UnitedHealth Group",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[3],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010931",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Walmart",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[3],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010932",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Berkshire Hathaway",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[5],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010933",
		filler: { done: 10, message: 20, invoices: 130 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Costco Wholesale",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[7],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 1,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010934",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Elevance Health",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[3],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010935",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Valero Energy",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[4],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 2,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010950",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Dell Technologies",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[4],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010951",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Netflix",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[7],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010952",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Coca Cola Company",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[7],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010953",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "FedEx",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[5],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010954",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
];

const ClientsProvider = ({ children }) => {
	const { isSignedIn, user } = useContext(AuthContext);

	const [clients, setClients] = useState(CLIENTS);

	//PART: Funtions

	const addNewClient = useCallback((newClient) => {
		setClients((oldValue) => {
			const newValue = [...oldValue, newClient];
			return newValue;
		});
	}, []);

	const updateCompanyInfo = useCallback(
		(clientId, newInfoObject) => {
			const isPersonalAccount = getItemWhere(clients, "id", clientId).companyType === 0;
			setClients((oldClients) => {
				if (isPersonalAccount) {
					const newClients = changeWhere(oldClients, "id", clientId, newInfoObject);
					return newClients;
				}
				const organizedNewInfoObject = {
					...getItemWhere(oldClients, "id", clientId),
					company: newInfoObject,
				};
				const newClients = changeWhere(oldClients, "id", clientId, organizedNewInfoObject);
				// newClients[clientIndex].company = newInfoObject;
				return newClients;
			});
		},
		[clients]
	);

	const updateCompanyInfoPartially = useCallback(
		(clientId, key, value) => {
			const clientIndex = getIndexWhere(clients, "id", clientId);
			const isPersonalAccount = clients[clientIndex].companyType === 0;
			setClients((oldClients) => {
				const newClients = [...oldClients];
				if (isPersonalAccount) {
					newClients[clientIndex][key] = value;
					return newClients;
				}
				newClients[clientIndex].company[key] = value;
				return newClients;
			});
		},
		[clients]
	);

	const updateEmployees = useCallback(
		(clientId, newClientList) => {
			const clientIndex = getIndexWhere(clients, "id", clientId);
			const isPersonalAccount = clients[clientIndex].companyType === 0;
			setClients((oldClients) => {
				if (isPersonalAccount) {
					return oldClients;
				}
				const newClients = [...oldClients];
				newClients[clientIndex].employees = newClientList;
				return newClients;
			});
		},
		[clients]
	);

	const downloadClient = useCallback((clientIndex) => {}, []);

	const deleteClient = useCallback((clientId) => {
		setClients((oldClients) => {
			const clientIndex = getIndexWhere(clients, "id", clientId);
			const newClients = [...oldClients];
			newClients.splice(clientIndex, 1);
			return newClients;
		});
	}, []);

	//PART: Value

	const value = useMemo(
		() => ({
			clients,
			addNewClient,
			updateCompanyInfo,
			updateCompanyInfoPartially,
			updateEmployees,
			downloadClient,
			deleteClient,
		}),
		[
			clients,
			addNewClient,
			updateCompanyInfo,
			updateCompanyInfoPartially,
			updateEmployees,
			downloadClient,
			deleteClient,
		]
	);

	if (!isSignedIn || user.type !== 0) return <>{children}</>;

	return <ClientsContext.Provider value={value}>{children}</ClientsContext.Provider>;
};

export default ClientsProvider;
